import React, { useEffect } from 'react';
import { getCurrentUser } from 'aws-amplify/auth';

const Callback: React.FC = () => {
  useEffect(() => {
    const handleCallback = async () => {
      try {
        await getCurrentUser();
        window.location.href = '/';
      } catch (error) {
        console.error('Callback error:', error);
        window.location.href = '/';
      }
    };

    handleCallback();
  }, []);

  return <div>Processing login...</div>;
};

export default Callback;